<template>
  <div class="home">
    <!-- banner -->
    <div class="bannerBox">
      <!-- 个人信息 -->
      <div class="bannerCenter">
        <div class="MemberCentre">
          <div class="userAvatar" :class="userStatus?'usermarginTop':''"><img src="../images/home/avatar.png" alt=""></div>
          <template v-if="userStatus" >
            <div class="userHi">{{userName}}</div>
            <div class="userText">{{homeToastText}}</div>
            <div class="userQuit" @click="userQuit"><img src="../images/home/quit.png" alt=""> 退出</div>
          </template>
          <template v-else>
            <div class="userHi">Hi~您好</div>
            <div class="userText">{{homeToastText}}</div>
            <ul class="userOerate">
              <li @click="loginBtn">登&nbsp;&nbsp;&nbsp;&nbsp;录</li>
              <li @click="registerBtn">注&nbsp;&nbsp;&nbsp;&nbsp;册</li>
            </ul>
          </template> 
        </div>
        <div class="bannerText"><img src="../images/home/banner_text.png" alt=""></div>
      </div>
      <img class="bannerImg" src="../images/home/banner.jpg" alt="">
    </div>
    <!-- 品牌LOGO设计 -->
    <div class="listBox">
      <div class="listTitle">
        <p><span>品牌LOGO设计</span><em>BRAND LOGO DESING</em></p>
        <router-link class="moreBtn" to="/brand">MORE<em>+</em></router-link>
      </div>
      <List :list="brandJson" :titleHref="'/brand'" :listLength="4" />
    </div>
    <!-- 软件服务 -->
    <div class="listBox">
      <div class="listTitle">
        <p><span>软件服务</span><em>SOFTWARE SERVICE</em></p>
        <router-link class="moreBtn" to="/serve">MORE<em>+</em></router-link>
      </div>
      <List :list="serveJson" :titleHref="'/serve'" :listLength="4" />
    </div>
    <!-- 电子商务 -->
    <div class="listBox">
      <div class="listTitle">
        <p><span>电子商务</span><em>E - COMMERCE</em></p>
        <router-link class="moreBtn" to="/business">MORE<em>+</em></router-link>
      </div>
      <List :list="businessJson" :titleHref="'/business'" :listLength="4" />
    </div>
    <!-- 动态资讯 -->
    <!-- <div class="listBox">
      <div class="listTitle">
        <p><span>动态资讯</span><em>INFORMATION</em></p>
        <router-link class="moreBtn" to="/news">MORE<em>+</em></router-link>
      </div>
      <div class="newsListBox">
        <NewsList :newsLength="5" />
      </div>
    </div> -->
    <!-- 登录弹窗 -->
    <IsLogin :isLoginShow="isLoginShow" :loginRegister="loginRegister" @isLoginShowBtn="isLoginShowBtn" @userStatusBtn="userStatusBtn"></IsLogin>
  </div>
</template>

<script>
import navBar from '@/components/navBar'
import List from '@/components/list'
import NewsList from '@/components/newsList'
import IsLogin from '@/components/isLogin'
import { brandJson, serveJson, businessJson } from '@/json/list';
// import { homeToastText } from '../util/index';

export default {
  name: 'Home',
  data() {
    return {
      brandJson: brandJson,  
      serveJson: serveJson,
      businessJson: businessJson,
      menuFixed: false,
      isLoginShow: false,   // 是否显示登录弹窗
      loginRegister: true,  // true: 登录层， false: 注册层
      userStatus: false,    // 是否是登录状态
      userName: '',
      homeToastText: homeToastText,
    }
  },
  mounted(){
  },
  methods:{
    // 是否显示登录弹窗
    isLoginShowBtn(){
      this.isLoginShow = false;
    },
    // 已登录-切换登录-会员中心
    userStatusBtn(e,user){
      if(e){
        this.userStatus = true;
        this.isLoginShow = false;
        this.userName = user.name;
      }
    },
    // 登录按钮
    loginBtn(){
      this.isLoginShow = true;
      this.loginRegister = true;
    },
    // 注册按钮
    registerBtn(){
      this.isLoginShow = true;
      this.loginRegister = false;
    },
    // 退出登录
    userQuit(){
      this.userStatus = false;
    },
  },
  components: {
    navBar,
    List,
    NewsList,
    IsLogin
  },
}
</script>


<style scoped lang="scss">

  %h-bgBox{
    @include h-radius(5px);
    @include h-bgColor(var(--colorFF));
  }
  
  .home{
    // background: #fff;
  }
  .bannerBox{
    height: 500px;
    overflow: hidden;
    position: relative;
    .bannerCenter{
      width:$navWidth;
      top:0;
      left:50%;
      height:100%;
      position: absolute;
      @extend %placeX;
      .bannerText{
        width:48%;
        top:36%;
        left:0;
        position: absolute;
      }
    }
    .bannerImg{
      height:100%;
      object-fit: cover;
    }
  }

  .MemberCentre{
    top:110px;
    right:0;
    width:280px;
    height:360px;
    text-align: center;
    position: absolute;
    backdrop-filter: blur(10px);
    @include h-radius(10px);
    @include h-bgColor(linear-gradient(215deg, var(--Member-left-bg), var(--Member-right-bg)));
    .userAvatar{
      margin:30px auto 0;
      @include h-avatar(88px, 88px, none, 50%, none);
    }
    .usermarginTop{
      margin-top:70px;
    }
    .userHi{
      margin: 25px 0 4px;
      @include h-fontSize(var(--color22),18px,28px);
    }
    .userText{
      @include h-fontSize(var(--color66),12px,22px);
    }
    .userQuit{
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:20px auto 0;
      @include h-btn(30%,32px, 12px,$colorFF,23px,0,linear-gradient(310deg, #eb3f3f, #eb3f3f),false,none);
      img{
        width:14px;
        margin-right:5px;
      }
      &:hover{
        opacity: 0.8;
      }
    }
    .userOerate{
      width:240px;
      margin:26px auto 0;
      li{
        cursor: pointer;
        margin-bottom:18px;
        transition: background 0.3s;
        @include h-btn(100%,40px, 14px,$colorFF,23px,0,linear-gradient(310deg, $colorF6, #52acff),false,none);
        &:hover{
          @include h-bgColor(linear-gradient(310deg, $colorE7, #44a5fe));
        }
      }
    }
  }


  .listBox{
    width:$navWidth;
    margin:24px auto 0;
    padding:24px 0 10px 0;
    // @extend %h-bgBox;
    .listTitle{
      margin-bottom:20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      @include h-fontSize(var(--color22),22px,38px);
      p{
        font-weight: bolder;
        display: flex;
        align-items: center;
        position: relative;
        span{
          z-index: 3;
          position: relative;
        }
        em{
          font-weight: normal;
          margin-left:10px;
          height:38px;
          @include h-fontSize($color99,13px,46px);
        }
        img{
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }
      .moreBtn{
        display: flex;
        align-items: center;
        padding: 0 8px;
        height:22px;
        transform: scale(0.8);
        margin-right:-8px;
        transition: all 0.3s;
        @include h-border(1px solid $color89);
        @include h-fontSize($color66,14px,20px);
        em{
          display: block;
          margin-left:4px;
          font-size:16px;
          line-height: 20px;
        }
        img{
          margin-left:3px;
          width:12px;
          height:12px;
        }
        &:hover{
            color:$colorFF;
            @include h-bgColor($colorE7);
            @include h-border(1px solid $colorE7);
        }
      }
    }
    .newsListBox{
      padding:0 20px;
      margin-bottom:20px;
      @include h-radius(3px);
      @include h-bgColor(var(--colorFF));
    }
  }


  .animationBg{
    animation: myfirst 5s infinite;
    -webkit-animation: myfirst 5s infinite;
  }
  @keyframes myfirst{
    0%{
      background: red;
    }
    50%{
      background:yellow;
    }
    100%{
      background: red;
    }
  }
  
  @-webkit-keyframes myfirst{
    0%{
      background: red;
    }
    50%{
      background:yellow;
    }
    100%{
      background: red;
    }
  }
</style>
